/**
 * Extrae mensajes de error legibles de una respuesta del backend Rendafin.
 *
 * El backend (api-rendafin `AllExceptionsFilter`) responde SIEMPRE con la forma
 * `{ error, msg, data }`. Para errores de validación (class-validator vía
 * `ValidationPipe`) los mensajes específicos en español viajan en
 * `data.errors` (array de strings) mientras que `msg` queda como genérico
 * ("Bad Request Exception"). Para otras excepciones `data.errors` puede ser un
 * string suelto, un objeto `{ msg }`, o no venir, y `msg` trae el detalle.
 *
 * Esta función normaliza todos esos casos y devuelve SIEMPRE al menos un
 * mensaje para mostrar al usuario, de modo que nunca se quede solo con el
 * genérico "Bad Request".
 *
 * `res` es el objeto ya mapeado por `ApiClass` (no el `HttpErrorResponse`
 * crudo): `ApiClass.catchError` preserva `e.error.data` en `res.data`.
 */
export function extractApiErrors(
  res: any,
  fallback = 'No se pudo completar la operación. Revisa los campos e inténtalo de nuevo.'
): string[] {
  const raw = res?.data?.errors;
  const list: string[] = [];

  if (Array.isArray(raw)) {
    for (const item of raw) {
      if (typeof item === 'string' && item.trim()) {
        list.push(item.trim());
      } else if (item && typeof item === 'object' && typeof item.msg === 'string' && item.msg.trim()) {
        list.push(item.msg.trim());
      }
    }
  } else if (typeof raw === 'string' && raw.trim()) {
    list.push(raw.trim());
  }

  if (list.length > 0) return list;

  const msg = typeof res?.msg === 'string' ? res.msg.trim() : '';
  // Ignorar el genérico de NestJS para no esconder el fallback útil.
  if (msg && !/^bad request/i.test(msg)) return [msg];

  return [fallback];
}
